import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import { api } from "@/lib/api";

// [Metin](https://...) şeklinde yazılan bağlantıları ve düz yapıştırılan
// URL'leri tıklanabilir linke çevirir.
function renderRichText(text) {
  const parts = [];
  const pattern = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s]+)/g;
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (match[1] && match[2]) {
      parts.push(
        <a key={key++} href={match[2]} target="_blank" rel="noopener noreferrer" className="text-gold underline hover:text-gold/80">
          {match[1]}
        </a>
      );
    } else if (match[3]) {
      parts.push(
        <a key={key++} href={match[3]} target="_blank" rel="noopener noreferrer" className="text-gold underline hover:text-gold/80">
          {match[3]}
        </a>
      );
    }
    lastIndex = pattern.lastIndex;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then(r => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="container-x py-32 text-center"><h1 className="font-display text-3xl">Yazı bulunamadı</h1><Link to="/blog" className="btn-outline mt-6 inline-flex">Blog'a Dön</Link></div>;
  if (!post) return <div className="container-x py-32 text-center text-white/50">Yükleniyor...</div>;

  return (
    <article>
      <div className="relative border-b border-white/10">
        <div className="absolute inset-0">
          <img src={post.cover_image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/85 to-black" />
        </div>
        <div className="container-x relative pt-16 pb-20 max-w-3xl">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold mb-8">
            <ArrowLeft className="w-4 h-4" /> Blog
          </Link>
          <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-white/50 mb-6">
            <Calendar className="w-3.5 h-3.5 text-gold" />
            {new Date(post.created_at).toLocaleDateString("tr-TR")}
            {post.tags?.[0] && (<><span>·</span><span className="text-gold">{post.tags[0]}</span></>)}
          </div>
          <h1 className="font-display text-4xl md:text-5xl leading-tight" data-testid="blog-title">{post.title}</h1>
          <p className="mt-5 text-lg text-white/70">{post.excerpt}</p>
        </div>
      </div>

      <div className="container-x py-16 max-w-3xl">
        <div className="prose-invert">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i}>{renderRichText(para)}</p>
          ))}
        </div>

        {post.tags?.length > 0 && (
          <div className="mt-12 flex flex-wrap gap-2">
            {post.tags.map((t) => (
              <span key={t} className="text-xs uppercase tracking-widest border border-gold-30 text-gold px-3 py-1">{t}</span>
            ))}
          </div>
        )}
      </div>
    </article>
  );
}
